export const SET_SHARED_PROFILE_USERS = 'SET_SHARED_PROFILE_USERS'
export const SET_UNSHARED_PROFILE_USERS = 'SET_UNSHARED_PROFILE_USERS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const RESET_SELECTED_USER = 'RESET_SELECTED_USER'
